import { LAYOUTS, ModalAlignmentEnum, } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { ButtonTypeTokens, ButtonWidthTypeToken, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, StackAlignItems, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { isMobile } from '../../configs/utils';
import { ACTION } from './types';
import { NoAction, YesAction } from "./actions";
import { heightMap } from "../../configs/height";
const _isMobile = isMobile();
export const template = async () => ({
    layout: {
        id: ROUTE.PARTNER_LOGOUT,
        type: LAYOUTS.MODAL,
        style: _isMobile ? {
            isPartnerPlatform: true,
            height: heightMap[ROUTE.PARTNER_LOGOUT]
        } : {
            //@ts-ignore
            isPartnerPlatform: true,
            alignment: ModalAlignmentEnum.CENTER,
        },
        widgets: [{ id: 'partnerLogoutContainer', type: WIDGET.STACK }],
    },
    datastore: {
        partnerLogoutContainer: {
            type: StackType.column,
            width: StackWidth.CONTENT,
            alignItems: StackAlignItems.center,
            padding: {
                top: SizeTypeTokens.XXXXL,
                bottom: SizeTypeTokens.XXXXL,
                left: SizeTypeTokens.XXXL,
                right: SizeTypeTokens.XXXL
            },
            widgetItems: [
                { id: 'partnerLogoutContainerT1', type: WIDGET.TEXT },
                { id: 'partnerLogoutContainerSpace1', type: WIDGET.SPACE },
                { id: 'partnerLogoutButtonContainer', type: WIDGET.STACK },
            ]
        },
        partnerLogoutContainerT1: {
            label: 'Are you sure you want to logout?',
            fontSize: FontSizeTokens.LG,
            fontWeight: '600',
            fontFamily: FontFamilyTokens.Poppins,
            lineHeight: 26
        },
        partnerLogoutButtonContainer: {
            type: StackType.row,
            width: StackWidth.CONTENT,
            widgetItems: [
                { id: 'YesBtn', type: WIDGET.BUTTON },
                { id: 'partnerLogoutContainerSpace0', type: WIDGET.SPACE },
                { id: 'NoBtn', type: WIDGET.BUTTON },
            ]
        },
        YesBtn: {
            label: '          Yes        ',
            type: ButtonTypeTokens.MediumFilled,
            width: ButtonWidthTypeToken.CONTENT,
            action: {
                type: ACTION.YES_ACTION,
                routeId: ROUTE.PARTNER_LOGOUT,
                payload: {}
            }
        },
        NoBtn: {
            label: '         No        ',
            type: ButtonTypeTokens.MediumSoftFilled,
            width: ButtonWidthTypeToken.CONTENT,
            action: {
                type: ACTION.NO_ACTION,
                routeId: ROUTE.PARTNER_LOGOUT,
                payload: {}
            }
        },
        partnerLogoutContainerSpace0: {
            size: SizeTypeTokens.XL
        },
        partnerLogoutContainerSpace1: {
            size: SizeTypeTokens.XXL
        }
    },
});
export const PartnerLogoutMF = {
    onLoad: async ({ ...props }) => {
        return Promise.resolve(template());
    },
    actions: {
        [ACTION.YES_ACTION]: YesAction,
        [ACTION.NO_ACTION]: NoAction
    },
};
